module.exports = __webpack_public_path__ + "static/media/podcast.add40f12.md";


//////////////////
// WEBPACK FOOTER
// ./src/markdown/podcast.md
// module id = 335
// module chunks = 0